import { initSentry, SentryEnvironment } from "@team-uep/vue-sentry";
import type { SentryOptions } from "@team-uep/vue-sentry";
import sentryConfig from "virtual:sentryclirc";

import { isDevEnv, isStagingEnv } from "@/utils";

import Package from "../package.json";

const ignoreErrors = [
  "Error: Failed to load iubenda script: event error", // iubenda error
  "GVLError", // iubenda error
  "Object Not Found Matching Id", // error due to the safe links being scanned by Outlook https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
  "Abort due to cancellation of share",
  "AbortError: Share canceled",
  "The operation was aborted",
];

function getSentryEnv() {
  if (isDevEnv()) {
    return SentryEnvironment.Development;
  }

  if (isStagingEnv()) {
    return SentryEnvironment.Staging;
  }

  return SentryEnvironment.Production;
}

const onBeforeSend: SentryOptions["beforeSend"] = (event, hint) => {
  const error = hint.originalException;

  // If the error is an instance of Error, try to match the message with a list of partial messages.
  if (error instanceof Error) {
    const partialMessages = [
      // Safari extension error.
      "safari-extension",
      // Safari iOS extension error.
      "safari-web-extension",
      // Chrome extension error.
      "chrome-extension",
      // Firefox extension error.
      "moz-extension",
      // Safari (WebKit) internal issues
      "TypeError: WebKit",
      // Firefox internal errors
      "NS_ERROR_",
      // Firefox internal errors
      "__firefox__",
    ];

    if (partialMessages.some((message) => error.message.includes(message))) {
      return null;
    }
  }

  return event;
};

export function loadSentry(app: SentryOptions["app"], router: SentryOptions["vueRouter"]) {
  initSentry({
    app,
    vueRouter: router,
    projectName: Package.name,
    projectVersion: Package.version,
    sentryclirc: sentryConfig.sentryclirc,
    projectEnv: getSentryEnv(),
    beforeSend: onBeforeSend,
    ignoreErrors,
  });
}
